
import defaultsDeep from 'lodash.defaultsdeep';


const quotationDefault = {
    email: null,
    description: '',
    private_note: '',
    empty_private_note:'',
    price: 0,
    pieces: 0,
    timeWorkInHours: null,
    picturesSelected: null,
    document_items : [],
    job : {
        customer :{
            email : ''
        }
    }
};

export function normalizeQuotation(quote) {
    quote = defaultsDeep(quote, quotationDefault);
    return quote;
}